// Onboarding orchestrator and status tracking
import { supabase } from '@/integrations/supabase/client';

// Available genres for selection
export const AVAILABLE_GENRES = [
  'Fiction', 'Non-fiction', 'Mystery', 'Romance', 'Sci-Fi', 'Fantasy',
  'Biography', 'History', 'Self-help', 'Business', 'Science', 'Philosophy'
];

// Popular books by genre for recommendations
export const POPULAR_BOOKS: Record<string, Array<{
  id: string;
  title: string;
  authors: string[];
  cover_url?: string;
  isbn13?: string;
  open_library_id?: string;
  subjects?: string[];
}>> = {
  'Fiction': [
    {
      id: 'book-1',
      title: 'The Seven Husbands of Evelyn Hugo',
      authors: ['Taylor Jenkins Reid'],
      cover_url: 'https://covers.openlibrary.org/b/isbn/9781501139239-M.jpg',
      isbn13: '9781501139239'
    },
    {
      id: 'book-2', 
      title: 'Where the Crawdads Sing',
      authors: ['Delia Owens'],
      cover_url: 'https://covers.openlibrary.org/b/isbn/9780735219090-M.jpg',
      isbn13: '9780735219090'
    },
    {
      id: 'book-3',
      title: 'The Midnight Library',
      authors: ['Matt Haig'],
      cover_url: 'https://covers.openlibrary.org/b/isbn/9780525559474-M.jpg',
      isbn13: '9780525559474'
    },
    {
      id: 'book-4',
      title: 'Circe',
      authors: ['Madeline Miller'],
      cover_url: 'https://covers.openlibrary.org/b/isbn/9780316556347-M.jpg',
      isbn13: '9780316556347'
    },
    {
      id: 'book-5',
      title: 'The Song of Achilles',
      authors: ['Madeline Miller'],
      cover_url: 'https://covers.openlibrary.org/b/isbn/9780062060624-M.jpg',
      isbn13: '9780062060624'
    }
  ],
  'Mystery': [
    {
      id: 'book-6',
      title: 'Gone Girl',
      authors: ['Gillian Flynn'],
      cover_url: 'https://covers.openlibrary.org/b/isbn/9780307588364-M.jpg',
      isbn13: '9780307588364'
    },
    {
      id: 'book-7',
      title: 'The Girl with the Dragon Tattoo',
      authors: ['Stieg Larsson'],
      cover_url: 'https://covers.openlibrary.org/b/isbn/9780307454546-M.jpg',
      isbn13: '9780307454546'
    },
    {
      id: 'book-8',
      title: 'In the Woods',
      authors: ['Tana French'],
      cover_url: 'https://covers.openlibrary.org/b/isbn/9780143113492-M.jpg',
      isbn13: '9780143113492'
    }
  ],
  'Romance': [
    {
      id: 'book-9',
      title: 'Beach Read',
      authors: ['Emily Henry'],
      cover_url: 'https://covers.openlibrary.org/b/isbn/9781984806734-M.jpg',
      isbn13: '9781984806734'
    },
    {
      id: 'book-10',
      title: 'The Hating Game',
      authors: ['Sally Thorne'],
      cover_url: 'https://covers.openlibrary.org/b/isbn/9780062439598-M.jpg',
      isbn13: '9780062439598'
    }
  ],
  'Sci-Fi': [
    {
      id: 'book-11',
      title: 'Dune',
      authors: ['Frank Herbert'],
      cover_url: 'https://covers.openlibrary.org/b/isbn/9780441013593-M.jpg',
      isbn13: '9780441013593'
    },
    {
      id: 'book-12',
      title: 'The Martian',
      authors: ['Andy Weir'],
      cover_url: 'https://covers.openlibrary.org/b/isbn/9780553418026-M.jpg',
      isbn13: '9780553418026'
    }
  ],
  'Fantasy': [
    {
      id: 'book-13',
      title: 'The Name of the Wind',
      authors: ['Patrick Rothfuss'],
      cover_url: 'https://covers.openlibrary.org/b/isbn/9780756404079-M.jpg',
      isbn13: '9780756404079'
    },
    {
      id: 'book-14',
      title: 'The Way of Kings',
      authors: ['Brandon Sanderson'],
      cover_url: 'https://covers.openlibrary.org/b/isbn/9780765326355-M.jpg',
      isbn13: '9780765326355'
    }
  ],
  'Non-fiction': [
    {
      id: 'book-15',
      title: 'Educated',
      authors: ['Tara Westover'],
      cover_url: 'https://covers.openlibrary.org/b/isbn/9780399590504-M.jpg',
      isbn13: '9780399590504'
    },
    {
      id: 'book-16',
      title: 'Sapiens',
      authors: ['Yuval Noah Harari'],
      cover_url: 'https://covers.openlibrary.org/b/isbn/9780062316097-M.jpg',
      isbn13: '9780062316097'
    }
  ],
  'Biography': [
    {
      id: 'book-17',
      title: 'Becoming',
      authors: ['Michelle Obama'],
      cover_url: 'https://covers.openlibrary.org/b/isbn/9781524763138-M.jpg',
      isbn13: '9781524763138'
    }
  ],
  'History': [
    {
      id: 'book-18',
      title: 'The Guns of August',
      authors: ['Barbara W. Tuchman'],
      cover_url: 'https://covers.openlibrary.org/b/isbn/9780345476098-M.jpg',
      isbn13: '9780345476098'
    }
  ],
  'Self-help': [
    {
      id: 'book-19',
      title: 'Atomic Habits',
      authors: ['James Clear'],
      cover_url: 'https://covers.openlibrary.org/b/isbn/9780735211292-M.jpg',
      isbn13: '9780735211292'
    }
  ],
  'Business': [
    {
      id: 'book-20',
      title: 'Good to Great',
      authors: ['Jim Collins'],
      cover_url: 'https://covers.openlibrary.org/b/isbn/9780066620992-M.jpg',
      isbn13: '9780066620992'
    }
  ],
  'Science': [
    {
      id: 'book-21',
      title: 'Astrophysics for People in a Hurry',
      authors: ['Neil deGrasse Tyson'],
      cover_url: 'https://covers.openlibrary.org/b/isbn/9780393609394-M.jpg',
      isbn13: '9780393609394'
    }
  ],
  'Philosophy': [
    {
      id: 'book-22',
      title: 'Meditations',
      authors: ['Marcus Aurelius'],
      cover_url: 'https://covers.openlibrary.org/b/isbn/9780140449334-M.jpg',
      isbn13: '9780140449334'
    }
  ]
};

export interface OnboardingStatus {
  hasProfile: boolean;
  hasUsername: boolean;
  hasAvatar: boolean;
  importComplete: boolean;
  bookshelfScanComplete: boolean;
  genresComplete: boolean;
  archetypeComplete: boolean;
  readingGoalSet: boolean;
  nextStep: 'profile' | 'import' | 'bookshelf-scan' | 'genres' | 'archetype' | 'reading-goal' | 'done';
  loading: boolean;
  error?: string;
  genreCount: number;
  scanCount?: number;
}

export async function getOnboardingStatus(userId: string): Promise<OnboardingStatus> {
  try {
    // Check user profile completion
    const { data: userProfile } = await supabase
      .from('users')
      .select('username, image')
      .eq('id', userId)
      .maybeSingle();

    const hasUsername = !!(userProfile?.username);
    const hasAvatar = !!(userProfile?.image);
    const hasProfile = hasUsername; // Avatar is optional

    // Check import completion - either has completed import OR skipped
    const { data: completedImports } = await supabase
      .from('import_jobs')
      .select('id')
      .eq('user_id', userId)
      .eq('status', 'complete')
      .limit(1);

    const { data: onboardingData } = await supabase
      .from('user_onboarding')
      .select('import_skipped')
      .eq('user_id', userId)
      .maybeSingle();

    const importComplete = !!(completedImports && completedImports.length > 0) || !!onboardingData?.import_skipped;

    // Check bookshelf scan completion (optional - at least 1 scan)
    const { data: scans } = await supabase
      .from('bookshelf_scans')
      .select('scan_number')
      .eq('user_id', userId);

    const scanCount = scans?.length || 0;
    const bookshelfScanComplete = scanCount > 0;

    // Check genres completion - minimum 3 required
    const { data: userGenres } = await supabase
      .from('user_genres')
      .select('id')
      .eq('user_id', userId);

    const genreCount = userGenres ? userGenres.length : 0;
    const genresComplete = genreCount >= 3;

    // Check archetype completion (from profiles table)
    const { data: profileData } = await supabase
      .from('profiles')
      .select('archetype')
      .eq('id', userId)
      .maybeSingle();

    const archetypeComplete = !!profileData?.archetype;

    // Check reading goal completion
    const { data: readingPrefs } = await supabase
      .from('user_reading_preferences')
      .select('weekly_reading_goal')
      .eq('user_id', userId)
      .maybeSingle();

    const readingGoalSet = !!readingPrefs;

    // Determine next step based on completion status
    let nextStep: OnboardingStatus['nextStep'] = 'done';
    if (!hasProfile) {
      nextStep = 'profile';
    } else if (!importComplete) {
      nextStep = 'import';
    } else if (!genresComplete) {
      nextStep = 'genres';
    } else if (!archetypeComplete) {
      nextStep = 'archetype';
    }

    return {
      hasProfile,
      hasUsername,
      hasAvatar,
      importComplete,
      bookshelfScanComplete,
      genresComplete,
      archetypeComplete,
      readingGoalSet,
      nextStep,
      loading: false,
      genreCount,
      scanCount,
    };
  } catch (error) {
    console.error('Error getting onboarding status:', error);
    return {
      hasProfile: false,
      hasUsername: false,
      hasAvatar: false,
      importComplete: false,
      bookshelfScanComplete: false,
      genresComplete: false,
      archetypeComplete: false,
      readingGoalSet: false,
      nextStep: 'profile',
      loading: false,
      error: 'Failed to check onboarding status',
      genreCount: 0,
      scanCount: 0,
    };
  }
}

export function getOnboardingNextUrl(status: OnboardingStatus): string {
  switch (status.nextStep) {
    case 'profile':
      return '/onboarding/profile';
    case 'import':
      return '/onboarding/import';
    case 'bookshelf-scan':
      return '/onboarding/bookshelf-scan';
    case 'genres':
      return '/onboarding/genres';
    case 'archetype':
      return '/onboarding/archetype';
    case 'reading-goal':
      return '/onboarding/reading-goal';
    case 'done':
      return '/';
    default:
      return '/onboarding/profile';
  }
}

export async function markImportSkipped(userId: string): Promise<void> {
  await supabase
    .from('user_onboarding')
    .upsert(
      {
        user_id: userId,
        import_skipped: true,
        updated_at: new Date().toISOString()
      },
      { onConflict: 'user_id' }
    );
}

export async function saveUserGenres(userId: string, genres: string[]): Promise<void> {
  if (genres.length === 0) return;

  const genreInserts = genres.map(genre => ({
    user_id: userId,
    genre
  }));

  const { error } = await supabase
    .from('user_genres')
    .upsert(genreInserts, { onConflict: 'user_id,genre' });

  if (error) throw error;
}

export async function getUserGenres(userId: string): Promise<string[]> {
  const { data, error } = await supabase
    .from('user_genres')
    .select('genre')
    .eq('user_id', userId);

  if (error) throw error;
  return data ? data.map(item => item.genre) : [];
}

export async function saveBookRatings(userId: string, bookRatings: Array<{ bookId: string; rating: number }>): Promise<void> {
  const ratedBooks = bookRatings
    .filter(({ rating }) => rating > 0)
    .map(({ bookId, rating }) => ({
      user_id: userId,
      book_id: bookId,
      rating_star: rating,
      preference_score: rating / 5,
      privacy: 'private' as const // Changed to private default
    }));

  if (ratedBooks.length > 0) {
    const { error } = await supabase
      .from('user_books')
      .upsert(ratedBooks, { onConflict: 'user_id,book_id' });

    if (error) throw error;
  }
}

export async function markGenresComplete(userId: string): Promise<void> {
  // Genres completion is determined by user_genres count.
  // This is a no-op to avoid writing to non-existent columns in user_onboarding.
  void userId;
  return;
}

export async function markGenresSkipped(userId: string): Promise<void> {
  // Skipping genres is handled via navigation only; no DB flags are required.
  void userId;
  return;
}
